export default {
  common: {
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    delete: '削除',
    edit: '編集',
    view: '表示',
    back: '戻る',
    close: '閉じる',
    add: '追加',
    send: '送信',
    sending: '送信中...',
    saving: '保存中...',
    loading: '読み込み中...',
    search: '検索',
    update: '更新',
    create: '作成',
    creating: '作成中...',
    transfer: '転送',
    approve: '承認',
    reject: '却下',
    ok: '了解',
    name: '名前',
    username: 'ユーザー名',
    password: 'パスワード',
    email: 'メール',
    date: '日付',
    status: 'ステータス',
    type: 'タイプ',
    quantity: '数量',
    description: '説明',
    project: 'プロジェクト',
    task: 'タスク',
    logout: 'ログアウト',
    notifications: '通知',
    settings: '設定',
    draft: '下書き',
    sent: '送信済み',
    active: '有効',
    inactive: '無効',
    priority: '優先度',
    language: '言語',
    yes: 'はい',
    no: 'いいえ',
    error: 'エラー',
    success: '成功',
    warning: '警告',
    required: '必須',
    optional: '任意',
    all: 'すべて',
    none: 'なし',
    upload: 'ファイルをアップロード',
    download: 'ダウンロード',
    print: '印刷',
    actions: 'アクション',
    details: '詳細',
    filters: 'フィルター',
    results: '結果',
    noResults: '結果が見つかりません',
    total: '合計',
    of: '/',
    verified: '確認済み',
    pending: '保留中',
    completed: '完了',
    cancelled: 'キャンセル済み',
  },

  auth: {
    login: 'ログイン',
    loginTitle: 'アカウントにログイン',
    logout: 'ログアウト',
    register: '登録',
    forgotPassword: 'パスワードをお忘れですか？',
    resetPassword: 'パスワードをリセット',
    usernameOrEmail: 'ユーザー名またはメール',
    enterPassword: 'パスワードを入力',
    enterUsername: 'ユーザー名を入力',
    loginError: 'ユーザー名またはパスワードが間違っています。',
    sessionExpired: 'セッションが期限切れです。再度ログインしてください。',
  },

  nav: {
    dashboard: 'ダッシュボード',
    overview: '概要',
    documents: 'ドキュメント',
    viewDocuments: 'ドキュメントを表示',
    manageProjects: 'プロジェクトを管理',
    viewProjects: 'プロジェクトを表示',
    manageUsers: 'ユーザーを管理',
    viewUsers: 'ユーザーを表示',
    manageWarehouse: '倉庫を管理',
    viewWarehouse: '倉庫を表示',
    manageMachinery: '機械を管理',
    viewMachinery: '機械を表示',
    manageSystem: 'システムを管理',
    projects: 'プロジェクト',
    myProjects: 'マイプロジェクト',
    myTasks: 'マイタスク',
    reports: 'レポート',
    drawings: '図面',
    warehouse: '倉庫',
    checkStock: '在庫を確認',
    requests: 'リクエスト',
    requestItem: 'アイテムをリクエスト',
    tickets: 'チケット',
    messages: 'メッセージ',
    adminMode: '管理者モード',
    standardMode: '標準モード',
    analystMode: 'アナリストモード',
    createReport: 'レポートを作成',
    createReports: '建設レポート',
    dailyReport: '日次建設レポート',
    incidentReport: 'インシデントレポート',
    safetySection: '労働安全',
    safetyDialog: '安全対話',
    workPermit: '危険作業許可証',
    occurrenceReport: '発生レポート',
    settingsMenu: '設定',
  },

  profile: {
    editProfile: 'プロフィールを編集',
    displayName: '名前',
    usernameLabel: 'ユーザー名',
    passwordLabel: 'パスワード',
    changePassword: 'パスワードを変更',
    appearance: '外観',
    lightMode: 'ライトモード',
    darkMode: 'ダークモード',
    languageLabel: '言語',
    cropTitle: 'プロフィール写真を切り抜く',
    cropUse: 'このエリアを使用',
    zoom: 'ズーム',
    currentPassword: '現在のパスワードを確認',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワードを確認',
    emailVerified: '確認済み',
    emailChange: '変更',
    emailSendCode: 'コードを送信',
    emailConfirm: '確認',
    emailResend: '← コードを再送',
    emailCancelChange: 'キャンセル',
    emailSending: '送信中...',
    emailVerifying: '確認中...',
    emailHint: '{email} にコードを送信しました。受信箱とスパムを確認してください。',
    emailSuccess: 'メール {email} の確認が完了しました。',
    emailInvalidError: '有効なメールアドレスを入力してください。',
    emailGenericError: 'コードの送信中にエラーが発生しました。',
    emailInvalidCode: '無効なコードです。',
    passwordFillAll: 'すべてのパスワードフィールドを入力してください。',
    passwordWrong: '現在のパスワードが間違っています。',
    passwordMismatch: '新しいパスワードの確認が一致しません。',
    saveFillAll: '名前とユーザー名を入力してください。',
    saveFinishPassword: '保存前にパスワード変更を完了またはキャンセルしてください。',
    avatarAlt: 'プロフィール',
  },

  dashboard: {
    overview: '概要',
    myProjects: 'マイプロジェクト',
    myTasks: 'マイタスク',
    activeProjects: '進行中のプロジェクト',
    completedTasks: '完了したタスク',
    pendingTasks: '保留中のタスク',
    recentActivity: '最近の活動',
    noProjects: 'プロジェクトが見つかりません。',
    noTasks: 'タスクが見つかりません。',
    createProject: 'プロジェクトを作成',
    projectName: 'プロジェクト名',
    startDate: '開始日',
    endDate: '終了日',
  },

  projects: {
    title: 'プロジェクト',
    newProject: '新規プロジェクト',
    projectName: 'プロジェクト名',
    startDate: '開始',
    endDate: '終了',
    progress: '進捗',
    team: 'チーム',
    gantt: 'ガントチャート',
    files: 'ファイル',
    tickets: 'チケット',
    warehouse: '倉庫',
    dds: '安全ミーティング',
    reports: 'レポート',
    noProjects: 'プロジェクトがありません。',
    deleteConfirm: 'このプロジェクトを削除しますか？',
  },

  tasks: {
    title: 'タスク',
    newTask: '新規タスク',
    taskName: 'タスク名',
    assignee: '担当者',
    dependencies: '依存関係',
    duration: '期間（日）',
    startDate: '開始',
    endDate: '終了',
    progress: '進捗',
    addProgress: '進捗を記録',
    noTasks: 'タスクがありません。',
    blocked: 'ブロック済み',
    inProgress: '進行中',
    done: '完了',
    deleteConfirm: 'このタスクを削除しますか？',
  },

  warehouse: {
    title: '倉庫',
    stock: '在庫',
    requestItem: 'アイテムをリクエスト',
    requests: 'リクエスト',
    addItem: 'アイテムを追加',
    itemName: 'アイテム名',
    category: 'カテゴリ',
    unit: '単位',
    available: '利用可能',
    reserved: '予約済み',
    transferItem: 'アイテムを転送',
    reportDamage: '損傷を報告',
    provideEquipment: '機器を提供',
    noItems: '在庫にアイテムがありません。',
    noRequests: 'リクエストがありません。',
    approveRequest: 'リクエストを承認',
    rejectRequest: 'リクエストを却下',
    requestStatus: {
      pending: '保留中',
      approved: '承認済み',
      rejected: '却下済み',
      delivered: '配送済み',
    },
  },

  safety: {
    title: '安全',
    dds: '安全ミーティング',
    ddsTitle: '日次安全対話',
    newDds: '新規安全ミーティング',
    occurrences: '発生事項',
    permits: '許可証',
    createDialog: '対話を作成',
    createOccurrence: '発生事項を記録',
    createPermit: '許可証を作成',
    topic: 'トピック',
    presenter: '発表者',
    attendees: '参加者',
    date: '日付',
    noSafety: '安全記録がありません。',
  },

  tickets: {
    title: 'チケット',
    newTicket: '新規チケット',
    subject: '件名',
    category: 'カテゴリ',
    openedBy: '作成者',
    assignedTo: '担当者',
    openTickets: 'オープンチケット',
    closedTickets: 'クローズドチケット',
    noTickets: 'チケットがありません。',
    status: {
      open: 'オープン',
      inProgress: '進行中',
      closed: 'クローズ',
    },
  },

  users: {
    title: 'ユーザー',
    newUser: '新規ユーザー',
    role: '役職',
    roles: {
      adminMaster: 'マスター管理者',
      adminObra: '現場管理者',
      user: 'ユーザー',
    },
    noUsers: 'ユーザーがありません。',
    deleteConfirm: 'このユーザーを削除しますか？',
    manageRoles: '役職を管理',
    manageUsers: 'ユーザー管理',
    userList: 'ユーザーリスト',
  },

  system: {
    title: 'システム設定',
    siteName: 'システム名',
    logo: 'ロゴ',
    loginBackground: 'ログイン背景',
    primaryColor: 'プライマリカラー',
    save: '設定を保存',
    saved: '設定を保存しました。',
  },

  reports: {
    title: 'レポート',
    daily: '日次レポート',
    incident: 'インシデントレポート',
    noReports: 'レポートがありません。',
    createReport: 'レポートを作成',
    date: '日付',
    author: '作成者',
    content: '内容',
  },

  machinery: {
    title: '重機',
    newMachine: '新規設備',
    machineName: '名前',
    model: 'モデル',
    plate: 'ナンバープレート',
    status: 'ステータス',
    noMachinery: '設備がありません。',
  },

  messenger: {
    title: 'メッセージ',
    newMessage: '新しいメッセージ',
    noMessages: 'メッセージがありません。',
    typeMessage: 'メッセージを入力...',
    send: '送信',
  },
}
